// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-education-js": () => import("./../src/templates/education.js" /* webpackChunkName: "component---src-templates-education-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

